module.exports = __webpack_public_path__ + "img/A1.3.14-firefighter.00ca531d.png";